// Common State.
const defaults = {
    menuOpen: false
};
  
  // Global module loaded on first app load.
  export default {
    namespaced: true,
  
    state: Object.assign({}, defaults),
  
    mutations: {
        setMenuOpen(state, menu) {
            state.menuOpen = menu;
        },
     
      clear (state) {
        state = Object.assign({}, defaults)
      }
    },
  
    actions: {
        setMenuOpen({ commit }, menu) {
            commit('setMenuOpen', menu);
        }

    }

};
